import styled from "styled-components"
import { device } from "breakpoints"

import { getSolidColor } from "../../utils/helpers/getSolidColor"

export const ChecklistContainer = styled.form`
  position: relative;
  @media ${device.desktop} {
    margin-bottom: 52px;
  }

  h3 {
    margin-bottom: 21px;
    @media ${device.desktop} {
      font-size: 32px;
      letter-spacing: -0.33px;
      line-height: 36px;
    }
  }
`

export const ItemContainer = styled.div`
  background: #f6f8fa;
  padding: 10px 15px 22px;
  margin-bottom: 20px;
  cursor: pointer;
  position: relative;

  @media ${device.desktop} {
    padding: 30px 30px;
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* outline: none; */
      cursor: pointer;
    z-index: 2;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  ::-ms-check{
    display:none
  }

 
  
    /* show checkmark pseudo when input is checked */
    :checked ~ span.checkmark {
      border: 1px solid ${props => getSolidColor(props.theme.site)};
      box-shadow: 0 1px 0 0 ${props => getSolidColor(props.theme.site)};
      svg {
        display: block;
      }
    }

  }

  > div.tip {

    border-top: 1px solid #d2d4e0;
    padding-top: 18px;
    margin-left: 39px;
    margin-right: 25px;
    margin-bottom: 0 !important;

    @media ${device.tablet} {
      padding-top: 10px;
      margin-left: 44px;

    }

    @media ${device.large} {
      padding-top: 10px;
      margin-left: 45px;
    }

    span {
      font-weight: 600;
      display:inline;
      color:black;
    }

    p, span {
      display:inline;
      font-size: 14px;
    letter-spacing: -0.11px;
    line-height: 18px;

    @media ${device.desktop} {
      font-size: 16px;
      letter-spacing: -0.12px;
      line-height: 30px;

    }
    }
  }
`
export const ChecklistInputContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  margin-bottom: ${props => (props.tip === "" ? 0 : "14px")};

  @media ${device.desktop} {
    margin-bottom: ${props => (props.tip === "" ? 0 : "20px")};
  }

  label {
    > p {
      padding-top: 13px;
      z-index: 2;
      width: 100%;
      cursor: pointer;
      margin-bottom: 0 !important;

      @media ${device.desktop} {
        font-size: 20px;
        letter-spacing: -0.16px;
        line-height: 30px;

        padding-top: 0;
      }

      a {
        font-weight: 600;
        position: relative;
        color: #000;
        background-image: ${props =>
          `linear-gradient(to right, ${getSolidColor(
            props.theme.site
          )}, ${getSolidColor(props.theme.site)})`};
        background-position: 0 100%;
        background-repeat: no-repeat;
        background-size: 100% 1px;
        pointer-events: all;
        z-index: 2;

        @media ${device.desktop} {
          background-position: 0 97%;
        }

        :hover {
          background-size: 100% 0px;
        }
      }
    }
  }

  > span {
    height: 30px;
    width: 30px;
    border-radius: 3px;
    display: block;
    border: 1px solid #d2d4e0;
    box-shadow: 0 1px 0 0 #d2d4e0;
    border-radius: 4px;
    position: relative;
    margin-top: 9px;
    background: white;
    margin-right: 12px;
    flex-shrink: 0;

    @media ${device.desktop} {
      margin-top: 0;
      padding: 6px;
      margin-right: 15px;
    }

    svg {
      display: none;
      width: 18px;
      height: 14px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      path {
        fill: ${props => getSolidColor(props.theme.site)};
      }
    }
  }
`
